import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Project Billing API functions
const getAllProjectBillings = async (params = {}) => {
  try {
    const response = await api.get('/project-billings', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching project billings:', error);
    throw error;
  }
};

const getProjectBillingById = async (id) => {
  try {
    const response = await api.get(`/project-billings/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching project billing:', error);
    throw error;
  }
};

const createProjectBilling = async (data) => {
  try {
    const response = await api.post('/project-billings', data);
    return response.data;
  } catch (error) {
    console.error('Error creating project billing:', error);
    throw error;
  }
};

const updateProjectBilling = async (id, data) => {
  try {
    const response = await api.put(`/project-billings/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating project billing:', error);
    throw error;
  }
};

const deleteProjectBilling = async (id) => {
  try {
    const response = await api.delete(`/project-billings/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting project billing:', error);
    throw error;
  }
};

const getProjectBillingStats = async () => {
  try {
    const response = await api.get('/project-billings/stats');
    return response.data;
  } catch (error) {
    console.error('Error fetching project billing stats:', error);
    throw error;
  }
};

const projectBillingService = {
  getAllProjectBillings,
  getProjectBillingById,
  createProjectBilling,
  updateProjectBilling,
  deleteProjectBilling,
  getProjectBillingStats
};

export default projectBillingService;

